import { render, staticRenderFns } from "./triangle.vue?vue&type=template&id=44272512&scoped=true&"
import script from "./triangle.vue?vue&type=script&lang=ts&"
export * from "./triangle.vue?vue&type=script&lang=ts&"
import style0 from "./triangle.vue?vue&type=style&index=0&id=44272512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44272512",
  null
  
)

export default component.exports